import * as React from "react";
import { Typography, Card, CardContent, CardActionArea, Box } from '@mui/material';
import Icon from 'components/Icon';


const StatCard = ({ variant, stat, accolade, name, info, link, icon }) => {
	let CardActionComponent = Box;
	let cardActionProps = {
		className: 'cardActionArea noHover',
	};
	if (link) {
		CardActionComponent = CardActionArea;
		cardActionProps = {
			className: 'cardActionArea',
			href: link,
			disableRipple: true,
		}
	}
	if (name) accolade = name;
	if (variant === 'dark') { 
		icon = '';
		info = '';
	}
	if (variant === 'gray-600') variant = '';
	return (
		<Card variant={`statCard${variant ? `--${variant}` : ''}`} image="true">
			<CardActionComponent {...cardActionProps}>
				<CardContent sx={{ display: "flex", flexDirection: "column", justifyContent: "center", alignItems: "center", textAlign: "center", padding: "0;" }}>
					{icon && <Box><Icon width={"80px"} symbol={icon} /></Box>}
					{stat && <Typography component='div' className="stat" variant={'h2'}>{stat}</Typography>}
					{accolade && <Typography component='div' className="accolade" variant={'h3__card'}>{accolade}</Typography>}
					{info && <Typography component='div' className="info" variant={'h4__card'}>{info}</Typography>}
				</CardContent>
			</CardActionComponent>
		</Card>
	)
};
export default StatCard;